import { createMuiTheme } from "@material-ui/core/styles";

// Create a theme instance.
const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  // overrides: {
  //   MuiTab: {
  //     root: {
  //       minWidth: "72px",
  //     },
  //   },
  // },
});

export default theme;
